import {
  allowedCharts,
  allowedGroupings,
  CHART_LABELS,
  GROUPING_LABELS,
  METRIC_LABELS,
  METRICS,
  RANGE_LABELS,
  RANGES,
  supportsRange,
  type WidgetSpec,
} from '../dashboard/spec';
import styles from './WidgetControls.module.scss';

interface WidgetControlsProps {
  spec: WidgetSpec;
  onChange: (patch: Partial<WidgetSpec>) => void;
}

export const WidgetControls = ({ spec, onChange }: WidgetControlsProps) => (
  <div className={styles.controls}>
    <label className={styles.control}>
      <span className={styles.label}>Data</span>
      <select
        value={spec.metric}
        onChange={(event) => onChange({ metric: event.target.value as WidgetSpec['metric'] })}
        aria-label="Data"
      >
        {METRICS.map((metric) => (
          <option key={metric} value={metric}>
            {METRIC_LABELS[metric]}
          </option>
        ))}
      </select>
    </label>
    <label className={styles.control}>
      <span className={styles.label}>Axis</span>
      <select
        value={spec.group_by}
        onChange={(event) => onChange({ group_by: event.target.value as WidgetSpec['group_by'] })}
        aria-label="Axis"
      >
        {allowedGroupings(spec.metric).map((grouping) => (
          <option key={grouping} value={grouping}>
            {GROUPING_LABELS[grouping]}
          </option>
        ))}
      </select>
    </label>
    {supportsRange(spec.metric) ? (
      <label className={styles.control}>
        <span className={styles.label}>Range</span>
        <select
          value={spec.range}
          onChange={(event) => onChange({ range: event.target.value as WidgetSpec['range'] })}
          aria-label="Range"
        >
          {RANGES.map((range) => (
            <option key={range} value={range}>
              {RANGE_LABELS[range]}
            </option>
          ))}
        </select>
      </label>
    ) : null}
    <label className={styles.control}>
      <span className={styles.label}>Chart</span>
      <select
        value={spec.chart}
        onChange={(event) => onChange({ chart: event.target.value as WidgetSpec['chart'] })}
        aria-label="Chart"
      >
        {allowedCharts(spec.group_by).map((chart) => (
          <option key={chart} value={chart}>
            {CHART_LABELS[chart]}
          </option>
        ))}
      </select>
    </label>
  </div>
);
